/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.6.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function MessageFromJSON(json) {
    return MessageFromJSONTyped(json, false);
}
export function MessageFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'messageId': !exists(json, 'messageId') ? undefined : json['messageId'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'messageDirection': !exists(json, 'messageDirection') ? undefined : json['messageDirection'],
        'messageText': !exists(json, 'messageText') ? undefined : json['messageText'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'creationTimestamp': !exists(json, 'creationTimestamp') ? undefined : (json['creationTimestamp'] === null ? null : new Date(json['creationTimestamp'])),
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : json['modifiedBy'],
        'modificationTimestamp': !exists(json, 'modificationTimestamp') ? undefined : (json['modificationTimestamp'] === null ? null : new Date(json['modificationTimestamp'])),
    };
}
export function MessageToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'messageId': value.messageId,
        'propertyId': value.propertyId,
        'messageDirection': value.messageDirection,
        'messageText': value.messageText,
        'createdBy': value.createdBy,
        'creationTimestamp': value.creationTimestamp === undefined ? undefined : (value.creationTimestamp === null ? null : value.creationTimestamp.toISOString()),
        'modifiedBy': value.modifiedBy,
        'modificationTimestamp': value.modificationTimestamp === undefined ? undefined : (value.modificationTimestamp === null ? null : value.modificationTimestamp.toISOString()),
    };
}
